import { useAuth } from '../auth/AuthContext';

/**
 * Devuelve el equipo actual desde el AuthContext (sin llamadas API adicionales).
 * El team se carga una sola vez al iniciar sesión y se comparte globalmente.
 */
export function useCurrentTeam() {
    const { team, loading } = useAuth();
    return { team, loading, error: null };
}
